// @flow

import CustomCheckbox from './CustomCheckbox';
import Notifications from '../constants/Notifications';

export default class SegmentsToggle extends CustomCheckbox {
  /**
   * @inheritDoc
   */
  onParentChange(): void {
    super.onParentChange();
    if (!(this.el instanceof HTMLInputElement)) return;

    if (!this.isChecked(this.el)) {
      this.uncheckAllChildren();
      return;
    }

    this.notify(Notifications.ACTIVATE_PARENT_TOGGLE);
    this.checkFirstTwoItems();
  }

  /**
   * Check the first two child boxes
   */
  checkFirstTwoItems(): void {
    this.check(this.childBoxes[0]);
    this.check(this.childBoxes[1]);
    this.activeChildrenAmount = 2;
  }

  /**
   * @inheritDoc
   */
  onChildChange(e: Event): void {
    super.onChildChange(e);

    if (!(this.el instanceof HTMLInputElement)) return;

    if (this.activeChildrenAmount) {
      this.check(this.el);
      return;
    }

    this.uncheck(this.el);
  }
}
